module.exports = __webpack_public_path__ + "static/media/buymeacoffee.38ef0fbf.svg";